<div class="container">
	<div class="row">
		<div class="col-12">

			<p class="text-center">
				<i class="fas fa-spinner fa-spin"></i>
				Sending you to the most recent symposium.
			</p>
		</div>
	</div>
</div>
